import { Icon, Th } from '@chakra-ui/react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Header = ({ column, setOrderBy, sortColumn, sortDirection }) => {
  const isSortColumn = sortColumn === column.key;
  const isSortable = !!column.sortable;

  const sortIcon =
    sortDirection === 'asc' ? (
      <Icon as={FontAwesomeIcon} icon={faChevronUp} />
    ) : (
      <Icon as={FontAwesomeIcon} icon={faChevronDown} />
    );

  return (
    <Th
      fontWeight={600}
      cursor={isSortable ? 'pointer' : undefined}
      key={column.label}
      pb={3}
      pt={4}
      _hover={
        isSortable && {
          opacity: 0.7,
        }
      }
      onClick={() => {
        // Do nothing if column is not sortable
        if (!isSortable) return;

        // Clear Sort if already sorting by column
        if (isSortColumn && sortDirection === 'desc') {
          setOrderBy({});
          return;
        }

        // Otherwise, toggle sort direction
        const newSortDirection = isSortColumn && sortDirection === 'asc' ? 'desc' : 'asc';
        setOrderBy({
          [column.key]: newSortDirection,
        });
      }}
    >
      {column.label} {isSortColumn && isSortable && sortIcon}
    </Th>
  );
};

export default Header;
